export function isValidRedirectUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

export function firstNonStringField(
  body: Record<string, unknown>,
  fields: readonly string[],
): string | null {
  for (const field of fields) {
    if (body[field] !== undefined && typeof body[field] !== "string") {
      return field;
    }
  }

  return null;
}

export function deriveMemberReferralCode({
  referral_code,
  rewardful_via,
  influencer_name,
}: {
  referral_code?: string | null;
  rewardful_via?: string | null;
  influencer_name: string;
}): string {
  const derivedCode = influencer_name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

  return referral_code?.trim() || rewardful_via || derivedCode || "link";
}
